import { useRouteMatch } from 'react-router';

import { MessageConfiguration } from 'pages/Private/Communications/MessageConfiguration';

import { Route } from '../Route';
export const CommunicationsRoutes = () => {
  const { url } = useRouteMatch();

  return (
    <>
      <Route isPrivate path={`${url}/message-configuration`} component={MessageConfiguration} />
    </>
  );
};
